module.exports = __webpack_public_path__ + "img/rkhy.2a272200.png";